import React from 'react';
import { useFormContext } from '../../components/FormContext';


const WorkStatusSection = () => {
  const { 
    formData, 
    formErrors, 
    modifiedFields,
    setFieldValue,
    setFormErrors, 
    setModifiedFields
  } = useFormContext();

const handleTextChange = (field, e) => {
    const value = e.target.value;
    setFieldValue(field, value);
    setModifiedFields(prev => new Set([...prev, field]));
    
    let error = null;
    if (value.trim() === '') {
     
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else if (/\d/.test(value)) {

      error = `${field.charAt(0).toUpperCase() + field.slice(1)} should not contain numbers`;

    }
    
    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };



    const validateTFN = (field, e) => {
      const value = e.target.value.replace(/\s/g, '');
    setFieldValue('tfnNumber', value);
    setModifiedFields(prev => new Set([...prev, field]));
    
    let error = null;
    if (value.trim() === '') {
     
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else {

        const cleanTfn = value.replace(/\s/g, '');
      if (!/^\d+$/.test(cleanTfn)) {
        error = 'Tfn number must contain only numbers';
      } else if (cleanTfn.length !== 9) {
        error = 'Tfn number must be 9 digits';
      }
      
      

    }
      
     
      
      
      if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
    };

const validateABN = (field, e) => {
      const value = e.target.value.replace(/\s/g, '');
    setFieldValue('abn', value);
    setModifiedFields(prev => new Set([...prev, field]));
    
    let error = null;
    if (value.trim() === '') {
     
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else {

        const cleanAbn = value.replace(/\s/g, '');
      if (!/^\d+$/.test(cleanAbn)) {
        error = 'Abn number must contain only numbers';
      } else if (cleanAbn.length !== 11) {
        error = 'Abn number must be 11 digits';
      }
      
      

    }
      
     
      
      
      if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
    };


const validateNumber = (field, e) => {
  // remove all spaces from the input as it's entered
  const value = e.target.value.replace(/\s/g, '');
  setFieldValue('membershipNumber', value);
  setModifiedFields(prev => new Set([...prev, field]));

  let error = null;
  if (value.trim() === '') {
    error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
  } else if (!/^\d+$/.test(value)) {
    error = 'Member number must contain only numbers';
  } else if (value.length < 5 || value.length > 15) {
    error = 'Member number must be between 5 and 15 digits';
  }

  if (error) {
    setFormErrors(prev => ({ ...prev, [field]: error }));
  } else {
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[field];
      return newErrors;
    });
  }
};


  return (
<div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Working Status Info</h4>
        <div className="space-y-4">
              <div>
                  <label htmlFor="work-status" className="block text-sm font-medium text-gray-700 mb-1">
                    Work Status
                  </label>
                  <input
                    type="text"
                    id="work-status"
                    name="workStatus"
                    value={formData.workStatus}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-md shadow-sm focus:outline-none"
                  />
                  <p className="text-sm text-gray-600 mt-1">
                    This value is pre-filled based on your account information and cannot be changed.
                  </p>
                </div>
                
                {formData.workStatus === 'TFN' && (
                  <>
                    <div>
                      <label htmlFor="tfn-number" className="block text-sm font-medium text-gray-700 mb-1">
                        TFN Tax Number
                      </label>
                      <input
                        type="text"
                        inputMode='numeric'
                        maxLength={9}
                        id="tfn-number"
                        name="tfnNumber"
                        value={formData.tfnNumber}
                        onChange={(e) => validateTFN('tfnNumber', e)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      />
                      
                      {formErrors.tfnNumber && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('tfnNumber') && (
                        <div className="text-sm text-red-600 mt-1">
                          {formErrors.tfnNumber}
                        </div>
                      )}
                    </div>
                    
                    <div>
                      <label htmlFor="super-fund-name" className="block text-sm font-medium text-gray-700 mb-1">
                        Super Fund Name
                      </label>
                      <input
                        type="text"
                        id="super-fund-name"
                        name="superFundName"
                        value={formData.superFundName}
                        onChange={(e) => handleTextChange('superFundName', e)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      />
                      
                      {formErrors.superFundName && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('superFundName') && (
                        <div className="text-sm text-red-600 mt-1">
                          {formErrors.superFundName}
                        </div>
                      )}
                    </div>
                    
                    <div>
                      <label htmlFor="super-fund-account-name" className="block text-sm font-medium text-gray-700 mb-1">
                        Super Fund Account Name
                      </label>
                      <input
                        type="text"
                        id="super-fund-account-name"
                        name="superFundAccountName"
                        value={formData.superFundAccountName}
                        onChange={(e) => handleTextChange('superFundAccountName', e)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      />
                      
                      {formErrors.superFundAccountName && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('superFundAccountName') && (
                        <div className="text-sm text-red-600 mt-1">
                          {formErrors.superFundAccountName}
                        </div>
                      )}
                    </div>
                    
                    <div>
                      <label htmlFor="membership-number" className="block text-sm font-medium text-gray-700 mb-1">
                        Membership Number
                      </label>
                      <input
                        type="text"
                        inputMode='numeric'
                        maxLength={15}
                        minLength={5}
                        id="membership-number"
                        name="membershipNumber"
                        value={formData.membershipNumber}
                        onChange={(e) => validateNumber('membershipNumber', e)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      />
                      
                      {formErrors.membershipNumber && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('membershipNumber') && (
                        <div className="text-sm text-red-600 mt-1">
                          {formErrors.membershipNumber}
                        </div>
                      )}
                    </div>
                  </>
                )}
                
                {formData.workStatus === 'ABN' && (
                  <div>
                    <label htmlFor="abn" className="block text-sm font-medium text-gray-700 mb-1">
                      ABN Number
                    </label>
                    <input
                      type="text"
                      inputMode='numeric'
                      maxLength={11}
                      id="abn"
                      name="abn"
                      value={formData.abn}
                      onChange={(e) => validateABN('abn', e)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                    
                    {formErrors.abn && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('abn') && (
                      <div className="text-sm text-red-600 mt-1">
                        {formErrors.abn}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

        


    );
};


export default WorkStatusSection;